// 'any' because currently this function is only used inside RHF input setter
// and it doesn't touch any non-library code.
export function normalizeString(value: string, normalizedValue: any = null) {
  if (value === '') {
    return normalizedValue;
  }

  return value;
}
